import React, { useState, useEffect } from 'react';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import Select from 'react-select';
import CreatePage from '../../../composents/CreatePage';

const title = 'Zones';
const headers = {
	icon: 'feather icon-plus',
	title: title,
	description: 'creation of new zone',
	breadcrumbs: [
		{
			title: title,
			link: '/meters/zones',
		},
	],
};

export default function CreateZone() {
	const [loader, setLoader] = useState(false),
		[clients, setClients] = useState([]),
		[errors, setErrors] = useState({}),
		[client, setClient] = useState();

	async function onGet() {
		let cli = await resources.customer
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (cli.status === 200) {
			let a = [];
			cli.data.docs.forEach((el) => {
				a.push({
					value: el.id,
					label: el.name,
				});
			});
			setClients(a);
		}
	}

	useEffect(() => {
		onGet();
	}, []);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		if (client) object.client = client.value;
		setLoader(true);
		setErrors({});
		let res = await resources.zone
			.create(object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/meters/zones');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<CreatePage show_error={errors['not_autorized']} headers={headers}>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Client{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => setClient(e)}
										options={clients}
										isSearchable
										isClearable
										className={
											errors['client']
												? ' is-invalid'
												: ''
										}
									/>
									{errors['client'] && (
										<div className="invalid-feedback">
											{errors['client']}
										</div>
									)}
								</div>

								<Field
									name="zone"
									className="mb-3"
									error={errors['zone']}
									required
								>
									Zone name
								</Field>

								<Field
									name="location"
									className="mb-3"
									error={errors['location']}
									required
								>
									Zone location
								</Field>

								<Field
									name="description"
									type="textarea"
									error={errors['description']}
									className="mb-3"
								>
									Note
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</CreatePage>
	);
}
